import { generateUUID } from "../../shared/services/utils";

export interface Bq3CrewManagementM {
  masterNationality: string;
  numberOfOfficers: string;
  listNationalityOfOfficers: string;
  nationalityOfRatings: NationalityOfRatingM[];
  commonWorkingLanguage: string;
  doOfficersSpeakEnglish: string;
  doOfficersSpeakEnglishComments: string;
  manningAgentOfficers: ManningAgentOfficerM[];
  manningAgentRatings: ManningAgentRatingM[];
}

export interface NationalityOfRatingM {
  id: string;
  nationalityId: string;
  nationality: string;
  count: string;
}

export interface ManningAgentOfficerM {
  id: string;
  officerId: string;
  companyName: string;
  address: string;
  phone: string;
  fax: string;
  email: string;
}

export interface ManningAgentRatingM {
  id: string;
  ratingId: string;
  companyName: string;
  address: string;
  phone: string;
  fax: string;
  email: string;
}

export const initialBq3CrewManagement: Bq3CrewManagementM = {
  masterNationality: "",
  numberOfOfficers: "",
  listNationalityOfOfficers: "",
  nationalityOfRatings: [
    {
      id: "",
      nationalityId: generateUUID(),
      nationality: "",
      count: "",
    },
  ],
  commonWorkingLanguage: "",
  doOfficersSpeakEnglish: "",
  doOfficersSpeakEnglishComments: "",
  manningAgentOfficers: [
    {
      id: "",
      officerId: generateUUID(),
      companyName: "",
      address: "",
      phone: "",
      fax: "",
      email: "",
    },
  ],
  manningAgentRatings: [
    {
      id: "",
      ratingId: generateUUID(),
      companyName: "",
      address: "",
      phone: "",
      fax: "",
      email: "",
    },
  ],
};

export function mapSqlToBq3CrewManagementForm(
  genInfo: any,
  nationalityOfRatings: any[],
  manningAgentOfficers: any[],
  manningAgentRatings: any[],
): Bq3CrewManagementM {
  return {
    masterNationality: genInfo?.MASTER_NATIONALITY || "",
    numberOfOfficers: genInfo?.NUMBER_OF_OFFICERS || "",
    listNationalityOfOfficers: genInfo?.LIST_NATIONALITY_OF_OFFICERS || "",
    commonWorkingLanguage: genInfo?.COMMON_WORKING_LANGUAGE || "",
    doOfficersSpeakEnglish: genInfo?.DO_OFFICERS_SPEAK_ENGLISH || "",
    doOfficersSpeakEnglishComments: genInfo?.DO_OFFICERS_SPEAK_ENGLISH_COMMENTS || "",
    nationalityOfRatings: nationalityOfRatings.map((rating) => ({
      id: rating?.ID || "",
      nationalityId: rating?.NATIONALITY_ID || "",
      nationality: rating?.NATIONALITY || "",
      count: rating?.COUNT || "",
    })),
    manningAgentOfficers: manningAgentOfficers.map((officer) => ({
      id: officer?.ID || "",
      officerId: officer?.OFFICER_ID || "",
      companyName: officer?.COMPANY_NAME || "",
      address: officer?.ADDRESS || "",
      phone: officer?.PHONE || "",
      fax: officer?.FAX || "",
      email: officer?.EMAIL || "",
    })),
    manningAgentRatings: manningAgentRatings.map((rating) => ({
      id: rating?.ID || "",
      ratingId: rating?.RATING_ID || "",
      companyName: rating?.COMPANY_NAME || "",
      address: rating?.ADDRESS || "",
      phone: rating?.PHONE || "",
      fax: rating?.FAX || "",
      email: rating?.EMAIL || "",
    })),
  };
}
